module.exports = __webpack_public_path__ + "img/banner2.5f07d2d0.jpg";